import * as React from "react";
import { useEffect, useState } from "react";
import { CommonHelper } from "../../../../../../react-core/Helpers/CommonHelper";
import { StringHelper } from "../../../../../../react-core/Helpers/StringHelper";
import { SelectEditor } from "../../../../../../react-core/Html/SelectEditor";
import { TextBoxEditor } from "../../../../../../react-core/Html/TextBoxEditor";
import { CompanySearchClient } from "../../../../../../Wrap/Api/Company/CompanySearch";
import { NetworkHistoryClient } from "../../../../../../Wrap/Api/Network/NetworkHistory";
import { CompanyDetailSort } from "../../../../../../Wrap/Constants/Enums/Domain/CompanyDetailSort";
import { FirmType } from "../../../../../../Wrap/Constants/Enums/Domain/FirmType";
import { MultiPropositionType } from "../../../../../../Wrap/Constants/Enums/Domain/MultiPropositionType";
import { NetworkType } from "../../../../../../Wrap/Constants/Enums/Network/NetworkType";
import { CompanySummary } from "../../../../../../Wrap/Models/Models/Company/CompanySummary";
import { NetworkHistoryModel } from "../../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { AdviserWizardAction } from "../../../../../Admin/Adviser/Actions/AdviserWizardAction";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { SearchInput } from "../../../../../Shared/SearchInput/SearchInput";
import { IBasicSearchQuery } from "../../ClientRecord/Action/AccountSearchAction";
import { accountStatusMap, accountTypeMap, ALL, ALL_NON_WRAP, ALL_WRAP } from "../../ClientRecord/Resource/Contents";

interface IBasicSearchProps {
    onSearch: (query: IBasicSearchQuery) => void;
    isSearching: boolean;
    fromToolAndLiterature?: boolean;
    ServicePropositionsToExclude?: MultiPropositionType[];
}
export const BasicSearch = (props: IBasicSearchProps) => {
    const [accountNum, setAccountNum] = useState(null);
    const [accountName, setAccountName] = useState(null);
    const [adviser, setAdviser] = useState(null);
    const [clientType, setClientType] = useState(null);
    const [status, setStatus] = useState(ALL);
    const [company, setCompany] = useState(null);
    const [network, setNetwork] = useState(null);
    const [adviserList, setAdviserList] = useState([]);
    const [displayNetworkSearch, setDisplayNetworkSearch] = useState(false);
    const [displayCompanySearch, setDisplayCompanySearch] = useState(false);
    const [errorMsg, setErrorMsg] = useState([]);

    useEffect(() => {
        const networkClient = new NetworkHistoryClient();
        networkClient.get(null, NetworkType.Unknown, null, null, null, false, 10, 1).onSuccess((result) => {
            if (result.TotalRows > 1) {
                setDisplayNetworkSearch(true);
            }
        });

        const companyClient = new CompanySearchClient();
        companyClient
            .get(null, null, FirmType.All, null, null, null, true, 1, 10, CompanyDetailSort.CompanyName,false)
            .onSuccess((result) => {
                if (result.TotalNumberOfResults > 1) {
                    setDisplayCompanySearch(true);
                } else if (result.TotalNumberOfResults == 1) {
                    getClientAllowedAdvisers(null, result.PageOfResults[0].CompanyCode);
                    setCompany(result.PageOfResults[0]);
                }
            });
    }, []);

    const getClientAllowedAdvisers = (network, company) => {
        if (CommonHelper.isNullOrEmpty(company) && CommonHelper.isNullOrEmpty(network)) {
            setAdviserList([]);
        } else {
            AdviserWizardAction.getAdviser(
                { Company: company, Network: network, CurrentPage: 1, ResultsPerPage: 999 },
                (result) => {
                    setAdviserList(result.Results);
                }
            );
        }
    };

    const checkValid = () => {
        let valid = true;
        const errorMsgArr = [];
        if (company == null) {
            errorMsgArr.push("Company is mandatory");
            valid = false;
        }
        setErrorMsg(errorMsgArr);
        return valid;
    };

    const networkClient = new NetworkHistoryClient();
    const companyClient = new CompanySearchClient();
    return (
        <>
            {errorMsg.length > 0 &&
                errorMsg.map((msg) => {
                    return <Alert alertType={AlertType.Error} message={msg}></Alert>;
                })}
            {props.fromToolAndLiterature && (
                <div className="row">
                    <div className="col-6">
                        <div className={"form-group search-form"}>
                            <label className="control-label">Account number</label>
                            <div className="controls-wrap">
                                <div className="controls-text">
                                    <span className="search-icon"></span>
                                    <input
                                        onChange={(v) => {
                                            const _v = StringHelper.stripSpecialCharacter(v.target.value);
                                            setAccountNum(_v);
                                        }}
                                        type="text"
                                        value={accountNum}
                                        maxLength={15}
                                        className="search-input"
                                        placeholder="Search by WP account number"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className={"form-group search-form"}>
                            <label className="control-label">Account name</label>
                            <div className="controls-wrap">
                                <div className="controls-text">
                                    <span className="search-icon"></span>
                                    <input
                                        onChange={(v) => setAccountName(v.target.value)}
                                        type="text"
                                        value={accountName}
                                        className="search-input"
                                        placeholder="Search by account name"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <div className="row">
                {displayNetworkSearch && (
                    <div className="col-6">
                        <SearchInput
                            apiClient={(v) => {
                                return networkClient.get(null, NetworkType.Unknown, v, null, null, false, 20, 1);
                            }}
                            onClick={(v) => {
                                getClientAllowedAdvisers(v?.Network, null);
                                setNetwork(v);
                                setCompany(null);
                                setAdviser(null);
                            }}
                            resultKey="networks"
                            getText={(v: NetworkHistoryModel) => v.NetworkName}
                            label={"Network"}
                            value={network?.NetworkName}
                        />
                    </div>
                )}
                {displayCompanySearch && (
                    <div className="col-6">
                        <SearchInput
                            apiClient={(v) => {
                                return companyClient.get(
                                    null,
                                    v,
                                    FirmType.All,
                                    null,
                                    network?.Network,
                                    null,
                                    true,
                                    1,
                                    20,
                                    CompanyDetailSort.CompanyName,
                                    false
                                );
                            }}
                            resultKey={"PageOfResults"}
                            onClick={(v) => {
                                getClientAllowedAdvisers(network?.Network, v?.CompanyCode);
                                setCompany(v);
                                setAdviser(null);
                            }}
                            getText={(v: CompanySummary) => v.CompanyName}
                            label={"Company"}
                            value={company?.CompanyName}
                        />
                    </div>
                )}
            </div>
            <div className="row">
                <div className="col-6">
                    <SelectEditor
                        id="Adviser"
                        label="Adviser"
                        options={[null].concat(adviserList)}
                        getText={(v) => {
                            return v ? v.Name : "All";
                        }}
                        selected={adviser}
                        onChange={(v) => setAdviser(v)}
                    />
                </div>
                {props.fromToolAndLiterature && (
                    <div className="col-3">
                        <SelectEditor
                            id="AccountType"
                            label="Account type"
                            getText={(v) => {
                                return v != null ? accountTypeMap[v] : "All";
                            }}
                            selected={clientType}
                            onChange={(v) => setClientType(v)}
                            options={[null].concat(Object.keys(accountTypeMap).map((ele) => Number(ele)))}
                        />
                    </div>
                )}
                {props.fromToolAndLiterature && (
                    <div className="col-3">
                        <SelectEditor
                            id="Status"
                            getText={(v) => {
                                return v == ALL
                                    ? "All"
                                    : v == ALL_WRAP
                                    ? "All Wrap"
                                    : v == ALL_NON_WRAP
                                    ? "All Non Wrap"
                                    : accountStatusMap[v];
                            }}
                            selected={status}
                            onChange={(v) => setStatus(v)}
                            label="Status"
                            options={[ALL, ALL_WRAP, ALL_NON_WRAP].concat(
                                Object.keys(accountStatusMap)
                                    .filter((key) => Number(key) !== 6)
                                    .map((ele) => Number(ele))
                            )}
                        />
                    </div>
                )}
            </div>
            <div className="row">
                <div className="col-fluid col-right col-top">
                    <button
                        className={`btn primary ${props.isSearching ? "is-busy" : ""}`}
                        onClick={() => {
                            if (!props.fromToolAndLiterature) {
                                if (checkValid()) {
                                    setErrorMsg([]);
                                    props.onSearch({
                                        accountName: accountName,
                                        accountNum: accountNum,
                                        status: status,
                                        network: network?.NetworkName,
                                        company: company?.CompanyName,
                                        accountType: clientType,
                                        adviser: adviser?.AdvCode,
                                    });
                                }
                            } else {
                                props.onSearch({
                                    ServicePropositionsToExclude: props.ServicePropositionsToExclude,
                                    accountName: accountName,
                                    accountNum: accountNum,
                                    status: status,
                                    network: network?.NetworkName,
                                    company: company?.CompanyName,
                                    accountType: clientType,
                                    adviser: adviser,
                                });
                            }
                        }}
                    >
                        Go
                    </button>
                </div>
            </div>
        </>
    );
};
